<template>
	<div class="right-0 flex items-center divide-won-gray-light md:absolute">
		<p class="mr-5 flex h-6 w-[103px] items-center justify-end text-[12px] text-won-dark-gray">
			Regenerate:</p>
		<div class="flex items-center justify-between">
			<button
				v-tooltip="{
					content: 'Select a paragraph to regenerate',
					placement: 'bottom',
					popperClass: 'text-center! text-[12px]! leading-[16px]! font-[Roboto] px-2 py-1 bg-dark-won-blue text-white'
				}"
				:class="[
					'mr-1 rounded-md border px-3 py-1.5 text-[12px]',
					isEnableRegenerateText
						? 'border-won-green text-won-green'
						: 'border-won-gray-light text-won-gray-light'
				]"
				:disabled="!isEnableRegenerateText"
				@click="emit('regenerate')"
			>
				Selected Text
			</button>

			<button
				class="mr-4 rounded-md border border-won-green px-3 py-1.5 text-[12px] text-won-green"
				@click="emit('regenerate', true)"
			>
				All Text
			</button>
		</div>
	</div>
</template>

<script setup>
import { defineEmits } from 'vue';
import { storeToRefs } from 'pinia';
import { useTiptapStore } from '../../store/tiptap.store';

const emit = defineEmits(['regenerate']);

const tipTapEditor = useTiptapStore();
const { isEnableRegenerateText } = storeToRefs(tipTapEditor);
</script>
